<div class="inv-monitor" role="region" aria-label="Indicadores de notas fiscais">
  <div *ngFor="let item of items; let last = last; trackBy: trackByLabel"
       class="inv-monitor__item"
       [class.inv-monitor__item--last]="last">
    <span class="inv-monitor__value" [ngClass]="item.valueClass">{{ item.value }}</span>
    <span class="inv-monitor__label">{{ item.label }}</span>
  </div>
</div>
